// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"c65c714c","830":"f99fe27d"}[chunkId] + ".chunk.js";
};